// src/context/ToastContext.js
import React, { createContext, useContext, useState } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: '', severity: 'success', open: false });

  const showToast = (message, severity = 'success') => {
    setToast({ message, severity, open: true });
  };

  const handleClose = () => {
    setToast(prev => ({ ...prev, open: false }));
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toast message={toast.message} severity={toast.severity} open={toast.open} onClose={handleClose} />
      {children}
    </ToastContext.Provider>
  );
};
